import { useSnapshots } from 'app/agriculture/queries/snapshots/useSnapshots';
import { useCallback } from 'react';
import { Device } from 'app/agriculture/queries/devices/types/Device';
import { validateLevelSnapshot } from 'app/agriculture/routes/Devices/utils/validateLevelSnapshot';

export function useGetLevelSnapshot() {
    const yarnLevelSnapshots = useSnapshots({
        snapshotType: 'Level',
        shelfLife: { hours: 1 },
    });
    const gasbotLevelSnapshots = useSnapshots({
        snapshotType: 'GasbotLevel',
        shelfLife: { hours: 12 },
    });

    return useCallback(
        (device: Device) =>
            validateLevelSnapshot(
                device.brand === 'Gasbot'
                    ? (gasbotLevelSnapshots.get(device.id) ?? null)
                    : (yarnLevelSnapshots.get(device.id) ?? null),
                { device },
            ),
        [yarnLevelSnapshots, gasbotLevelSnapshots],
    );
}
